import { Getter, GetterTree } from 'vuex'

import { IUploadStore } from '@/features/upload/store'

import {
  GET_UPLOAD_DATA
} from '@/system/store/getter-types'

const getUploadData: Getter<IUploadStore, any> = (state: IUploadStore) => {
  return state
}

const getters: GetterTree<IUploadStore, any> = {
  [ GET_UPLOAD_DATA ]: getUploadData
}

export default getters
